<template>
	<div>
        <Loading :value="loading" ></Loading>
        <v-dialog v-model="dialogDemande" width="80%" :persistent="true"  transition="dialog-bottom-transition" scrollable>
            <v-card tile>
                <v-toolbar card dark color="primary">
                    <v-toolbar-title>Ajouter ou modifier une demande de maintenance</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click.native="closeDialog()">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <el-form id="formDemande"  :model="formDemande" :rules="rules" ref="formDemande" class="demo-form-inline">
                        <v-layout row>
                            <v-flex xs4 class="mr-1" >
                                <el-form-item label="Lieu" prop="lieu">
                                <el-select  v-model="formDemande.lieu" name="lieu" placeholder="lieu" style="width: 100%">
                                    <el-option v-for="item in listeLieux" :key="item.value" :label="item.text" :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>
                            </v-flex>

                             <v-flex xs4 class="mr-1" >
                                 <el-form-item label="Type de la demande" prop="typeDemande">
                                <el-select  v-model="formDemande.typeDemande" name="typeDemande" placeholder="Type de la demande" style="width: 100%">
                                    <el-option v-for="item in typeDemande" :key="item.value" :label="item.text" :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>
                             </v-flex>

                              <v-flex xs4 class="mr-1" >
                                 <el-form-item label="Nom du demandeur" prop="demandeur">
                                    <el-autocomplete  v-model="formDemande.demandeur" name="demandeur" placeholder="nom du demandeur"  style="width: 100%" :fetch-suggestions="loadDemandeur" ></el-autocomplete>
                                </el-form-item>
                              </v-flex>
                        </v-layout>

                        <v-layout row>
                            <v-flex xs4 class="mr-1" >
                                <el-form-item label="Contact 1 du demandeur" prop="tel1">
                                    <el-input  v-model="formDemande.tel1" name="tel1" placeholder="Contact 1 du demandeur"  style="width: 100%"></el-input>
                                 </el-form-item>
                            </v-flex>

                             <v-flex xs4 class="mr-1" >
                                 <el-form-item label="Contact 2 du demandeur" prop="tel2">
                                    <el-input  v-model="formDemande.tel2" name="tel2" placeholder="Contact 2 du demandeur"  style="width: 100%"></el-input>
                                </el-form-item>
                             </v-flex>

                              <v-flex xs4 class="mr-1" >
                                <el-form-item label="Bâtiment" prop="batiment">
                                    <el-input  v-model="formDemande.batiment" placeholder="bâtiment"  style="width: 100%" ></el-input>
                                </el-form-item>
                              </v-flex>
                        </v-layout>

                        <v-layout row>
                            <v-flex xs4 class="mr-1" >
                               <el-form-item label="Salle" prop="salle">
                                <el-input  v-model="formDemande.salle" name="salle" placeholder="salle"  style="width: 100%"></el-input>
                            </el-form-item>
                            </v-flex>

                             <v-flex xs4 class="mr-1" >
                                 <el-form-item label="Priorité" prop="priorite">
                                <el-select  v-model="formDemande.priorite" name="priorite" placeholder="Type de la priorité" style="width: 100%">
                                    <el-option v-for="item in priorite" :key="item.value" :label="item.text" :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>
                             </v-flex>

                              <v-flex xs4 class="mr-1" >
                                   <el-form-item label="Description" prop="description">
                                <el-input type="textarea"  v-model="formDemande.detail" name="motif" placeholder="motif"  style="width: 100%"></el-input>
                            </el-form-item>
                              </v-flex>
                        </v-layout>

                        <v-layout row>
                            <v-flex xs4 class="mr-1">
                             <el-form-item label="Corps de metier" prop="domaine">
                                <el-select  v-model="formDemande.domaine" name="domaine" placeholder="Corps de metier" style="width: 100%">
                                    <el-option v-for="item in listeDomaine" :key="item.value" :label="item.text" :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>
                            </v-flex>
                             <v-flex md4 >
                                <el-form-item label="Date de la maintenance"  style="width:100%">
                                    <el-date-picker  v-model="formDemande.dateDemande" format="dd-MM-yyyy HH:mm" type="datetime" value-format="yyyy-MM-dd HH:mm " id="DateMaint" placeholder="Date de maintenance" style="width:100%">
                                    </el-date-picker>
                                </el-form-item>
                            </v-flex>
                        </v-layout>





                         <v-layout row>
                            <v-flex xs2 class="mr-1" >
                                 <v-avatar :tile="true" size="140px" height="120px" color="grey lighten-4"> <img :src="image1" alt="avatar"></v-avatar>
                                 <v-layout row>
                                    <input name="image1" type="file" style="display:none" ref="file1" accept="image/*" @change="onFileImage1Picked"/>
                                        <v-btn color="primary" class="white--text" required @click.native="$refs.file1.click()">Photo  <v-icon right dark>cloud_upload</v-icon></v-btn>
                                        <div class="font-weight-thin" >Fichier au format (JPEG,PNG,PDF) avec une taille de 1048 ko maximale</div>
                                </v-layout>
                            </v-flex>

                             <!-- <v-flex xs2 class="mr-1" >
                                 <v-avatar :tile="true" size="140px" height="120px" color="grey lighten-4"> <img :src="image2" alt="avatar"></v-avatar>
                                 <v-layout row>
                                    <input name="image2" type="file" style="display:none" ref="file2" accept="image/*" @change="onFileImage2Picked"/>
                                        <v-btn color="primary" class="white--text" required @click.native="$refs.file2.click()">Photo  <v-icon right dark>cloud_upload</v-icon></v-btn>
                                </v-layout>
                             </v-flex>

                              <v-flex xs2 class="mr-1" >
                                   <v-avatar :tile="true" size="140px" height="120px" color="grey lighten-4"> <img :src="image3" alt="avatar"></v-avatar>
                                 <v-layout row>
                                    <input name="image3" type="file" style="display:none" ref="file3" accept="image/*" @change="onFileImage3Picked"/>
                                        <v-btn color="primary" class="white--text" required @click.native="$refs.file3.click()">Photo  <v-icon right dark>cloud_upload</v-icon></v-btn>
                                </v-layout>
                              </v-flex> -->
                        </v-layout>

                        <v-layout row >
                            <v-flex xs12>
                            <el-form-item  class="text-xs-right" >
                               <v-btn color="grey"  @click="resetForm('formDemande')" dark>Annuler <v-icon right>remove_circle</v-icon></v-btn>
                               <v-btn v-if="editForm == false" icons dark color="green" @click="submitForm('formDemande')">Enregistrer<v-icon right>add</v-icon></v-btn>
                               <v-btn v-else  icons dark color="green" @click="submitForm('formDemande')">Enregistrer<v-icon right>add</v-icon></v-btn>
                            </el-form-item>
                            </v-flex>
                        </v-layout>
                    </el-form>
                </v-card-text>
                <div style="flex: 1 1 auto;"></div>
            </v-card>
        </v-dialog>

	</div>
</template>


<script>
    import Loading from '@/components/Loading'
    export default {
	components:{ Loading },
        name: "AjoutMaintenance",
        props:["show","demandeDetail","editForm"],
        data()
        {
         return {
            //data general
            domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
            user: JSON.parse(sessionStorage.getItem("userInfo")),
            roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),

            loading: false,
            labelPosition: 'left',
            dialogDemande: false,
            formDemande: {},
            listeLieux: [],
            listeDomaine: [],
            today: new Date(),
            image1: "/static/img-doc.png",
            image2: "/static/img-doc.png",
            image3: "/static/img-doc.png",
            image4: "/static/img-doc.png",
            file1: "",
            file2: "",
            file3: "",
            priorite:[
                { text: 'Faible', value: 0 },
                { text: 'Moyen', value: 1 },
                { text: 'Haute', value: 2 },
                { text: 'Urgent', value: 3 }
            ],
            typeDemande: [
                { text: 'Réparation', value: 1 },
                { text: 'Fourniture de matériel', value: 2 },
                { text: 'Entretien', value: 3 },
            ],
                 rules: {

                typeDemande: [
                    { required: true, message: 'Veuillez saisir' },

                ],
                 lieu: [
                    { required: true, message: 'Veuillez saisir' },

                ],
                 priorite: [
                    { required: true, message: 'Veuillez saisir'},

                ],
                demandeur: [
                    { required: true, message: 'Veuillez saisir', trigger: 'change' },

                ],
                 batiment: [
                    { required: true, message: 'Veuillez saisir', trigger: 'blur' },
                ],
                 salle: [
                    { required: true, message: 'Veuillez saisir', trigger: 'blur' },
                ],
                 tel1: [
                    { required: true, message: 'Veuillez saisir' },
                ],
                 domaine: [
                    { required: true, message: 'Veuillez saisir' },
                ],
            }
         }
        },

        computed:{

        },
         watch: {
            show : function(newValue, oldvalue){
               this.dialogDemande = newValue
               if(newValue == true){
                   if(this.editForm == true){

                   this.formDemande.lieu = this.demandeDetail.idZone
                   this.formDemande.typeDemande = this.demandeDetail.typeDemande
                   this.formDemande.demandeur = this.demandeDetail.nomDemandeur
                   this.formDemande.tel1 = this.demandeDetail.persTel1
                   this.formDemande.tel2 = this.demandeDetail.persTel2
                   this.formDemande.batiment = this.demandeDetail.batiment
                   this.formDemande.salle = this.demandeDetail.salle
                   this.formDemande.priorite = this.demandeDetail.priorite
                   this.formDemande.detail = this.demandeDetail.commentaire
                   this.formDemande.domaine =  this.demandeDetail.domaine
                   }
               }else {
                   this.formDemande = {}
               }
            }
        },

        methods: {
        createFilter(queryString) {
          return (link) => {
              return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
          };
        },
          closeDialog(){
            this.$emit('close')
        },
        submitForm(formName) {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              this.loading = true;
              let form = document.getElementById("formDemande")
              //recuperation des demandes
              let data = new FormData(form);
              let url = "";
              if( this.editForm == false ){
                  url = this.domaine + 'demande_maintenance/new'
              }
              else {
                  url = this.domaine + 'demande_maintenance/edit'
                  data.append("idDemande",this.demandeDetail.idDemande)
              }

              data.append("priorite",this.formDemande.priorite)
              data.append("typeDemande",this.formDemande.typeDemande)
              data.append("lieu",this.formDemande.lieu)
              data.append("batiment",this.formDemande.batiment)
              data.append("domaine",this.formDemande.domaine)

              if(this.formDemande.dateDemande != "undefined")
              {
                   data.append("dateMaint",this.formDemande.dateDemande)
              }
              data.append("userId",this.user.id)
              this.$http.post(url, data).then(response => {
                  //reinitialiser le formulaire
                  this.resetForm('formDemande')
                  this.formDemande.detail = ''
                  //reinitialisation des images telecharger
                  this.image1 = "/static/img-doc.png";
                  this.image2 = "/static/img-doc.png";
                  this.image3 = "/static/img-doc.png";
                  this.image = "/static/img-doc.png";
                  this.file1 = "";
                  this.file2 = "";
                  this.file3 = "";
                  this.loading = false
                  if(response.body.code == 5){
                      this.successNotif(response.body.message,"error")
                  }else{
                      this.successNotif(response.body.message)
                  }

                  this.closeDialog()
              }, (erreur) => {
                  //reinitialiser le formulaire
                  this.resetForm('formDemande')
                    this.formDemande.detail = ''
                  //reinitialisation des images telecharger
                    this.image1 = "/static/img-doc.png";
                    this.image2 = "/static/img-doc.png";
                    this.image3 = "/static/img-doc.png";
                    this.image = "/static/img-doc.png";
                    this.file1 = "";
                    this.file2 = "";
                    this.file3 = "";
                  this.closeDialog()
                  this.loading = false
                  this.$message.error("Une erreur est survenue lors de l'enregistrement de la demande")
              })
            }
          });
        },

        createFilter(queryString) {
            return (link) => {
                return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
            };
        },
      resetForm(formName) {
          console.log("resetForm")
        this.$refs[formName].resetFields();
      },
       loadDemandeur(queryString, cb) {
            let url = this.domaine +  'maintenance/listes-demandeur'
            var formdata = new FormData();
            formdata.append('user', this.user.id)
            formdata.append('tag', queryString)
            this.$http.post(url, formdata).then(response => {
                if (response.body) {
                    var links = response.body;
                    var results = queryString ? links.filter(this.createFilter(queryString)) : links;
                    cb(results);
                }
            },
            response => {
            })
        },

         loadLieu() {
            let url = this.domaine +  'demande_maintenance/lieu/'+ this.user.id

            this.$http.get(url).then(response => {
                console.log("lieux")
                console.log(response.body.lieux)
                    this.listeLieux = response.body.lieux;
                },
                erreurRep => {
                })
        },

         loadDomaine() {
            let url = this.domaine +  'demande_maintenance/liste/domaine'

            this.$http.get(url).then(response => {
            console.log("domaine")
            console.log(response.body.domaine)
                this.listeDomaine = response.body.domaine;
            },
            erreurRep => {
            })
        },

        successNotif(mess = "Demande enregistrée avec succès",type = "success"){
            this.$notify({
                    title: 'ENREGISTREMENT DEMANDE',
                    message: mess,
                    type: type,
                    position: 'top-center',
                    duration: 10000
            })
        },

        //enregistrement des images
        onFileImage1Picked(event)
        {
            const files = event.target.files
            let filename = files[0].name
            if (filename.lastIndexOf(".") <= 0)
            {
                return alert("Veuillez selectionner un  format de fichier valide ")
            }

            const fileReader = new FileReader()
            fileReader.addEventListener("load", () => {
                this.image1 = fileReader.result
            })

            fileReader.readAsDataURL(files[0])
            this.file1 = files[0]
        },
         //enregistrement des images
        onFileImage2Picked(event)
            {
                const files = event.target.files
                let filename = files[0].name
                if (filename.lastIndexOf(".") <= 0)
                {
                    return alert("Veuillez selectionner un  format de fichier valide ")
                }

                const fileReader = new FileReader()
                fileReader.addEventListener("load", () => {
                    this.image2 = fileReader.result
                })

                fileReader.readAsDataURL(files[0])
                this.file2 = files[0]
            },

         //enregistrement des images
        onFileImage3Picked(event)
            {
                const files = event.target.files
                let filename = files[0].name
                if (filename.lastIndexOf(".") <= 0)
                {
                    return alert("Veuillez selectionner un  format de fichier valide ")
                }

                const fileReader = new FileReader()
                fileReader.addEventListener("load", () => {
                    this.image3 = fileReader.result
                })

                fileReader.readAsDataURL(files[0])
                this.file3 = files[0]
            }
      },


        mounted(){
            this.loadLieu()
            this.loadDomaine()
        }

    }
    </script>



// WEBPACK FOOTER //
// src/components/maintenance/AjoutMaintenance.vue